import { render, staticRenderFns } from "./sequencing-technology-type-selector.vue?vue&type=template&id=6701a4b8&"
import script from "./sequencing-technology-type-selector.vue?vue&type=script&lang=js&"
export * from "./sequencing-technology-type-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports